import React, {
  createElement,
  Fragment,
  useEffect,
  useRef,
  useState,
} from "react";
import { render } from "react-dom";
import { usePagination, useSearchBox } from "react-instantsearch-hooks";
import { autocomplete } from "@algolia/autocomplete-js";
import { debounce } from "@algolia/autocomplete-shared";

import "@algolia/autocomplete-theme-classic";

const Autocomplete = ({
  searchClient,
  isTutorial = false,
  className,
  ...autocompleteProps
}) => {
  const autocompleteContainer = useRef(null);

  const { query, refine: setQuery } = useSearchBox();
  const { refine: setPage } = usePagination();

  const [instantSearchUiState, setInstantSearchUiState] = useState({ query });

  const debouncedSetInstantSearchUiState = debounce(
    setInstantSearchUiState,
    500
  );

  useEffect(() => {
    setQuery(instantSearchUiState.query);
    setPage(0);
  }, [instantSearchUiState, setQuery, setPage]);

  useEffect(() => {
    if (!autocompleteContainer.current) {
      return;
    }
    const autocompleteInstance = autocomplete({
      ...autocompleteProps,
      container: autocompleteContainer.current,
      initialState: { query },
      classNames: {
        form: "bg-white dark:bg-slate-900/80 ",
        input: "text-sm !text-slate-800 dark:!text-slate-100 form-input",
      },
      onReset() {
        setInstantSearchUiState({ query: "" });
      },
      onSubmit({ state }) {
        setInstantSearchUiState({ query: state.query });
      },
      onStateChange({ prevState, state }) {
        if (prevState.query !== state.query) {
          debouncedSetInstantSearchUiState({
            query: state.query,
          });
        }
      },
      renderer: { createElement, Fragment, render },
    });

    return () => autocompleteInstance.destroy();
  }, []);

  return (
    <div
      className={className}
      ref={autocompleteContainer}
    />
  );
};

export default Autocomplete;
